export function moodForSuccess(v: number): string {
  if (v >= 70) return "good";
  if (v >= 40) return "warn";
  return "bad";
}

export function moodForEffortOrCost(v: number): string {
  if (v < 30) return "good";
  if (v < 60) return "warn";
  return "bad";
}
